import { AddToPhotos } from '@mui/icons-material';
import { Col, Progress, Row } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import ImageHighlighterAdmin from "components/NonNativeAdmin/ImageHIghlighterAdmin";
import { find } from "lodash";
import { useCurrentUser } from "store/users/selectors";
import { imageUploader } from "utils/methods/imageUploader";
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from "utils/constants/enum"
import DefinitionVideosDownloadToolbar from 'components/AdminBooks/DefinitionVideosDownloadToolbar';


const ImageContainer = styled.div`
    height: auto;
    flex: 1;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;
const Container = styled.div`
    min-height: 75vh;
    width: 100%;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

const Page = styled.div`
    align-items: center;
    color: ${COLOR.black100};
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
`;


const Input = styled.input`
    background-color: transparent;
    border: 1px dashed gray;
    border-radius: 3px;
    box-shadow: none;
    font-size: inherit;
    font-weight: 400;
    outline: none;
    padding: 0px 2px;
    transition: all 300ms ease;
    width:250px;
`;

const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const Column = styled(Col)`
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;
export default function Pages({ src, onChange, description, onChangeDescription, style, hasDescription = true, pageId, path, onLoading, bookId, booksAllList }) {
    const showAlert = useAlert();
    const [pagePoster, setpagePoster] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)
    const [imageConfiguration, setImageConfiguration] = useState({});
    const book = find(booksAllList, bk => bk.id == bookId)
    const currentUser = useCurrentUser()
    useEffect(() => {
        setpagePoster(src)
    }, [src])
    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file, pageId)
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
            // onChange({url:v, pageId})
        };
    };
    const callLoader = (val) => {
        setLoader(val);
        if (onLoading) {
            onLoading(val)
        }
    }

       const uploadToStorage = async (file, index) => {
            if (file) {
                try { 
                    callLoader(true);
                    const onProgress = (per) => {
                        setLoadingMap(per);
                        callLoader(true);
                    };
                    const download_url = await imageUploader(file, onProgress,UPLOAD_IMAGE_TO_FIREBASE)
                    if (download_url) {
                        onChange({ url: download_url, pageId: index });
                    } else {
                        showAlert("Unable to upload image.", 'error')
                    }
                } catch (error) {
                    Sentry.captureException(`291 Error getting download URL: ${error}`);
                    console.error("Upload error", error);
                    showAlert("Having issue while uploading image", 'error')
                } finally {
                    callLoader(false);
                    setLoadingMap(0);
                }
            } else {
                console.log("No file to upload.");
            }
        };
    const onSelectImage = (v, index) => {
        onChange({ url: v, pageId: index });
        setpagePoster(v)
    }

    const getSrcPage = useCallback((page) => {
        return pagePoster;
        // }, [data, pageId, ebookFlagTeacherEdition, ebookFlag])
    }, [pageId])

    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            {hasDescription ? <Row style={{ height: 30 }}>
                <Col span={24} style={{ display: "flex", flexDirection: "row" }}>
                    <Page>
                        description :&nbsp; <Input type="text" value={description || ''} onChange={e => onChangeDescription(e.target.value)} />
                    </Page>
                </Col>
            </Row> : null}
            <Container empty={!pagePoster} >
                {/* <Img
                    style={{ height: "auto", width: "100%", border: `1px solid ${COLOR.black800}` }}
                    src={pagePoster}
                    loader={<Loading />}
                /> */}
                {/* {loader&& <Loading size={24} /> } */}
                {false ?
                    <>
                        <Images src={pagePoster} />
                          <MultiFileUploader inModal buttonClass={"file-uploader"} onSelect={v=>{ onSelectImage(v, pageId) }} buttonStyle={{ top:"35%"}}/>
                        <FileUploader
                            classes={"file-uploader"}
                            handleChange={handleChange}
                            name="file"
                            types={IMAGE_FILE_TYPE}
                        >
                            <FileUploadArea>
                                {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                                <Row className="box box-1">
                                    <Column span={2}>
                                        <AddToPhotos color="primary" />
                                    </Column>
                                    <Column span={17}>
                                        <Text>
                                            Upload or drop a file right here
                                        </Text>
                                    </Column>
                                    <Column span={4}>
                                        <Text>
                                            {IMAGE_FILE_TYPE.join(",")}
                                        </Text>
                                    </Column>
                                </Row>
                            </FileUploadArea>
                        </FileUploader>
                    </>
                    :
                    <>
                        <DefinitionVideosDownloadToolbar bookId={bookId} pageId={pageId} />
                        <ImageHighlighterAdmin
                            isNonNative={true}
                            imageUrl={pagePoster} 
                            userId={currentUser?.id}
                            pageId={pageId} 
                            bookId={bookId} 
                            setImageConfiguration={setImageConfiguration} 
                            imageConfiguration={imageConfiguration}
                            path={path}
                            onLoading={onLoading}
                            onChange={onChange} 
                            setpagePoster={setpagePoster} 
                        />
                        {/* )} */}
                    </>
                }
            </Container>
        </ImageContainer>
    )
}
